// Legacy Dugout drawings carry no `fieldVariation` — the pitch is expressed only by the
// `backgroundImage` PNG (`…/field01.png`, `field02.png`, `field03.png`, `field-futsal.png`). Map that
// filename to the rinus fieldType variation so import selects the right pitch (Dugout itself keys the
// field off `backgroundImage.src`). Unknown / absent → `field-01` (Dugout's default empty pitch).
const deriveDugoutFieldVariation = (backgroundSrc = ''): string => {
  if (backgroundSrc.includes('futsal')) return 'field-futsal';
  if (backgroundSrc.includes('field02')) return 'field-02';
  if (backgroundSrc.includes('field03')) return 'field-03';
  return 'field-01';
};

export default deriveDugoutFieldVariation;
